import React, { Component } from 'react'
import { Line } from 'react-chartjs-2'
import { format } from 'date-fns'
import { thousandSeparator } from '../../utils/Utils'
import 'chartjs-plugin-style'

class MChartMulti extends Component {
  state = {
    ticks: {
      labels: [],
      datasets: [
        {
          label: 'Затраты',
          fill: false,
          lineTension: 0.1,
          backgroundColor: '#8866ff',
          borderColor: '#8866ff',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: '#8866ff',
          pointBackgroundColor: '#8866ff',
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: '#8866ff',
          pointHoverBorderColor: '#8866ff',
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 8,
          data: [],
          borderWidth: 2,
          lineTension: 0,
          yAxisID: 'y-axis-1',
        },
        {
          label: 'Продажи',
          fill: false,
          lineTension: 0.1,
          backgroundColor: '#4cd964',
          borderColor: '#4cd964',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: '#4cd964',
          pointBackgroundColor: '#4cd964',
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: '#4cd964',
          pointHoverBorderColor: '#4cd964',
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 8,
          data: [],
          borderWidth: 2,
          lineTension: 0,
          yAxisID: 'y-axis-2',
        },
      ],
    },
    currency: this.props.currency,
  }

  componentDidMount() {
    this.costs = this.props.data.map(({ cost }) => cost)
    this.revenues = this.props.data.map(({ revenue }) => revenue)
    this.times = this.props.data.map(({ time }) => format(time, 'DD.MM'))

    this.setState({
      ticks: {
        labels: this.times,
        datasets: [
          {
            ...this.state.ticks.datasets[0],
            data: this.costs,
          },
          {
            ...this.state.ticks.datasets[1],
            data: this.revenues,
          },
        ],
      },
    })
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.data !== this.props.data) {
      this.costs = this.props.data.map(({ cost }) => cost)
      this.revenues = this.props.data.map(({ revenue }) => revenue)
      this.times = this.props.data.map(({ time }) => format(time, 'DD.MM'))

      this.setState({
        ticks: {
          labels: this.times,
          datasets: [
            {
              ...this.state.ticks.datasets[0],
              data: this.costs,
            },
            {
              ...this.state.ticks.datasets[1],
              data: this.revenues,
            },
          ],
        },
      })
    }
  }

  render() {
    const { ticks, currency } = this.state
    console.log(currency);
    const options = {
      maintainAspectRatio: false,
      title: {},
      legend: {
        display: false,
      },
      scales: {
        yAxes: [
          {
            type: 'linear',
            display: this.costs && this.costs.length > 0 ? true : false,
            position: 'left',
            id: 'y-axis-1',
            ticks: {
              min: 0,
              precision: 0,
              maxTicksLimit: 4,
              type: 'logarithmic',
              beginAtZero: false,
              fontFamily: "'Exo 2', 'Helvetica', 'Arial'",
              fontSize: 10,
              callback: function(value, index, values) {
                return value >= 1000 ? value / 1000 + ' тыс.' : value
              },
            },
            gridLines: {
              display: this.costs && this.costs.length > 0 ? true : false,
              drawBorder: false,
              drawOnChartArea: true,
            },
            scaleLabel: {
              labelString: 'Затраты',
              display: true,
            },
          },
          {
            type: 'linear',
            display: this.revenues && this.revenues.length > 0 ? true : false,
            position: 'left',
            id: 'y-axis-2',
            ticks: {
              min: 0,
              precision: 0,
              maxTicksLimit: 4,
              type: 'logarithmic',
              beginAtZero: false,
              fontFamily: "'Exo 2', 'Helvetica', 'Arial'",
              fontSize: 10,
              callback: function(value, index, values) {
                return value >= 1000 ? value / 1000 + ' тыс.' : value
              },
            },
            gridLines: {
              display: this.costs && this.costs.length ? false : true,
              color:
                this.costs && this.costs.length
                  ? '#979797'
                  : 'rgba(0, 0, 0, 0.1)',
            },
            scaleLabel: {
              labelString: 'Продажи',
              display: true,
            },
          },
        ],
        xAxes: [
          {
            ticks: {
              precision: 0,
              maxTicksLimit: 15,
              beginAtZero: false,
              fontFamily: "'Exo 2', 'Helvetica', 'Arial'",
              maxRotation: 0,
              minRotation: 0,
              fontColor: '#000000',
            },
            gridLines: {
              display: true,
              color: '#979797',
              drawBorder: true,
              drawOnChartArea: false,
            },
          },
        ],
      },
      tooltips: {
        caretSize: 0,
        displayColors: false,
        xPadding: 10,
        yPadding: 10,
        titleFontFamily: "'Exo 2', 'Helvetica', 'Arial'",
        titleFontSize: 14,
        titleFontColor: '#000',
        titleFontStyle: 'normal',
        titleMarginBottom: 10,
        bodyAlign: 'left',
        bodyFontColor: '#979797',
        bodyFontSize: 16,
        bodyFontFamily: "'Exo 2', 'Helvetica', 'Arial'",
        backgroundColor: '#ffffff',
        shadowOffsetX: 0,
        shadowOffsetY: 16,
        shadowBlur: 32,
        shadowColor: 'rgba(0, 0, 0, 0.12)',
        caretPadding: 15,
        callbacks: {
          label: function(tooltipItem, data) {
            const label = data.datasets[tooltipItem.datasetIndex].label || ''
            return `${label}:  ${thousandSeparator(tooltipItem.value)} ${currency}`
          },
        },
      },
      hover: {
        mode: 'nearest',
        intersect: true,
      },
    }

    return <Line ref="chart" data={ticks} options={options} />
  }
}

export default MChartMulti
